import React from 'react';
import PropTypes from 'prop-types';

const Button = props =>
  (
    <button
      className={`btn ${props.type} ${props.size} ${props.className}`}
      onClick={props.onClick}
      disabled={props.disabled}
    >
      {props.text}
    </button>
  );

Button.defaultProps = {
  size: '',
  className: '',
  disabled: false,
};

Button.propTypes = {
  type: PropTypes.string.isRequired,
  size: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

export default Button;
